import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { overline, colors, fonts, spacing } from 'ui/theme';
import { PAGE_HEADER_VARIANTS } from 'ui/pageHeader/constants';

export const BreadcrumbContainer = styled.div`
  display: inline-flex;
`;

export const StyledLink = styled(Link)`
  ${overline}
  align-items: center;
  color: ${colors.textSecondary};
  display: flex;
  font-family: ${fonts.sansSerif};
  margin-bottom: ${spacing.plusHalf};
  text-decoration: none;
  &:hover {
    color: ${colors.textPrimary};
  }
  &[data-variant=${PAGE_HEADER_VARIANTS.SECONDARY}] {
    margin-bottom: ${spacing.half};
  }
`;

export const StyledAnchor = styled.a`
  ${overline}
  align-items: center;
  color: ${colors.textSecondary};
  display: flex;
  font-family: ${fonts.sansSerif};
  margin-bottom: ${spacing.plusHalf};
  text-decoration: none;
  &:hover {
    color: ${colors.textPrimary};
  }
  &[data-variant=${PAGE_HEADER_VARIANTS.SECONDARY}] {
    margin-bottom: ${spacing.half};
  }
`;

export const StyledButton = styled.div`
  ${overline}
  align-items: center;
  color: ${colors.textSecondary};
  cursor: pointer;
  display: flex;
  font-family: ${fonts.sansSerif};
  margin-bottom: ${spacing.plusHalf};
  text-decoration: none;
  &:hover {
    color: ${colors.textPrimary};
  }
  &[data-variant=${PAGE_HEADER_VARIANTS.SECONDARY}] {
    margin-bottom: ${spacing.half};
  }
`;
